module.exports = __webpack_public_path__ + "assets/ic_firecracker.c8b369f7.svg";